import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateListBy extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("RoadMap/CreateListBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetDefaultRoadmaps extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Roadmap/GetDefaultRoadMap");
  }
}
export { CreateListBy, GetDefaultRoadmaps };
